import styled from "styled-components";
import { ColorTheme, ShadowTheme, BorderRadiusTheme, SpacingTheme } from "../../../../components/globaStyledComponents/globalStyledComponentsStyling";
export const ViewListingDesktopMenuWrapper = styled.div`
    display: none;

    @media (min-width: 1024px) {
        width: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    @media (min-width: 1280px) {
        width: 376px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
    }
`;
export const ViewListingDesktopMenu = styled.div`
    width: 100%;
    box-shadow: ${ShadowTheme.shadow_300.boxShadow};
    border-radius: ${BorderRadiusTheme.radius_24.borderRadius};
    margin: 0 0 48px;
    padding: ${SpacingTheme.spacing_400.padding} 24px 0;
    position: sticky;
    top: 80px;

    @media (max-width: 1023px) {
        display: none;
    }
    @media (min-width: 1280px) {
        margin-right: 0;
    }
`;
export const ViewListingDesktopMenuPrice = styled.div`
    width: 162px;
    height: 25px;
    background-color: ${ColorTheme.Grey2.color};
    border-radius: 5px;
`;
export const ViewListingDesktopMenuDatesWrapper = styled.div`
    width: 100%;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    border: 1px solid ${ColorTheme.Grey1.color};
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: 50% 50%;
    height: 128px;
    margin-top: 20px;
`;
export const ViewListingDesktopMenuDatesItem = styled.div`
    width: 100%;
    height: 100%;
    text-align: left;
    display: flex;
    padding: 11px 16px;
    flex-direction: column;
`;
export const ViewListingDesktopMenuDatesItemTitle = styled.div`
    width: 34px;
    height: 15px;
    border-radius: 5px;
    background-color: ${ColorTheme.Grey2.color};
    margin-bottom: 5px;
`;
export const ViewListingDesktopMenuDatesItemSubtitle = styled.div`
    width: 79px;
    height: 20px;
    border-radius: 5px;
    background-color: ${ColorTheme.Grey2.color};
`;
export const ViewListingFooterButton = styled.div`
    width: 100%;
    height: 48px;
    grid-row: 1/2;
    grid-column: 2/3;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    background-color: ${ColorTheme.Grey2.color};
    @media (min-width: 1024px) {
        margin-top: 16px;
    }
`;
export const ViewListingDesktopMenuDatesSelectSubtitle = styled.div`
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 12px;
    width: 100px;
    height: 20px;
    background-color: ${ColorTheme.Grey2.color};
    border-radius: 5px;
`;
